import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';

export const dcCustomerSchema = baseObjectSchema.extend({
  customerId: z.string().optional(),
  representativeId: z.string(),
  customerRemotedCode: z.string(),
  customer: z
    .object({
      id: z.string(),
      profession: z.string().optional(),
      code: z.string(),
      trader: z.object({
        id: z.string(),
        name: z.string(),
      }),
    })
    .optional(),
  representative: z
    .object({
      id: z.string(),
      name: z.string(),
      code: z.string(),
    })
    .optional(),
});

export const getDCCustomersResponseSchema = z.object({
  data: z.array(dcCustomerSchema),
  count: z.number(),
});

export type GetDCCustomersResponse = z.infer<typeof getDCCustomersResponseSchema>;
